// ================================================================================
// script.js
// 案件用のスクリプトファイル
// ================================================================================

// DOM Read for Vanilla
// --------------------------------------------------------------- //

document.addEventListener('DOMContentLoaded', () => {

	// breakpoint
	const breakpoint = window.matchMedia( 'screen and (min-width: 960px)' )

	// scroll volume
	function getScrolled() {
		return ( window.pageYOffset !== undefined ) ? window.pageYOffset: document.documentElement.scrollTop;
	}



	// variable
	// --------------------------------------------------------------- //

	// scroll
	let scrollTop = window.pageYOffset

	// url
	let url = location.href



	// Dropdown for mobile
	// --------------------------------------------------------------- //

	const dropDownButton = document.getElementById('js-mobile-menu')
	const menuOpenTarget = document.querySelector('body')
	//const dropDownMenu   = document.getElementById('js-site-menu')

	if ( dropDownButton ) {
		dropDownButton.addEventListener('click', function() {
			dropDownButton.classList.toggle('is-close')
			menuOpenTarget.classList.toggle('is-menu-open')
			//dropDownMenu.classList.toggle('is-active')
		} )
	}


	// ;only Front Page
	// Main Swiper
	// --------------------------------------------------------------- //

	const swiperId = document.getElementById('front-main-swiper')

	if ( swiperId ) {
		const swiper = new Swiper(swiperId, {
			loop: true,
			effect: 'slide',
			// 自動再生
			autoplay: {
				delay: 4000,
				disableOnInteraction: false,
			},
			speed: 1500,
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
		});
	}

} );


$(function() {

	// sp menu toggle
	// --------------------------------------------------------------- //

	$('.js-site-menu-toggole').click(function() {
		$(this).closest('.has-children').find('.js-site-menu-child').slideToggle('fast');
		$(this).toggleClass('is-open');
	} );

	$('.header-menu-item.has-children').hover(
		function (){
			$('.site-header-container').addClass('is-dropdown-open');
		},
		function () {
			$('.site-header-container').removeClass('is-dropdown-open');
		}
	);


	// form privacy check
	// --------------------------------------------------------------- //
	if ( $('.js-privacy').length ) {
		privacyFlag();
	}

	$('.js-privacy').click(function() {
		privacyFlag();
	} );

	function privacyFlag() {
		if ( $('.js-privacy').prop('checked') == true ) {
			$('.js-submit').prop('disabled', false);
		} else {
			if ( !$('body').hasClass('confirm') ) {
				$('.js-submit').prop('disabled', true);
			}
		}
	}


	// knee page
	// --------------------------------------------------------------- //
	$('.js-knee-toggle').click(function() {
		var $target = $(this).closest('.knee-toggle-title');
		var $target_icon = $target.find('.knee-toggle-icon');
		var $target_content = $target.next();
		$target_content.slideToggle();
		$target_icon.toggleClass('knee-toggle-icon--close')
		return false;
	} );

	$('.js-faq-toggle').click(function () {
		$(this).find('.knee-faq-box-head__icon').toggleClass('knee-faq-box-head__icon--close');
		$(this).next('.knee-faq-box-body').slideToggle();
		return false;
	});

	var $win = $(window),
		winHeight = $win.height();
	$win.resize(function(){
		winHeight = $win.height();
	});
	var h = 169;

	$(window).on('load scroll resize', function() {
		var scl = $win.scrollTop();
		if( scl >= h ) {
			if ( !$('.header').hasClass('header--front') ) {
				$('.header').addClass('header--small');
			}
		} else {
			if ( !$('.header').hasClass('header--front') ) {
				$('.header').removeClass('header--small');
			}
		}
	} );


});




